package dev.jfronny.zerointerest.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.CompareArrows
import androidx.compose.material.icons.automirrored.filled.NoteAdd
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Paid
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.Button
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExperimentalMaterial3ExpressiveApi
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.FloatingActionButtonMenu
import androidx.compose.material3.FloatingActionButtonMenuItem
import androidx.compose.material3.Icon
import androidx.compose.material3.LoadingIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.PlainTooltip
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.ToggleFloatingActionButton
import androidx.compose.material3.TooltipAnchorPosition
import androidx.compose.material3.TooltipBox
import androidx.compose.material3.TooltipDefaults
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteItem
import androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteScaffold
import androidx.compose.material3.rememberTooltipState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.navigation3.runtime.entryProvider
import androidx.navigation3.ui.NavDisplay
import de.connect2x.trixnity.client.MatrixClient
import de.connect2x.trixnity.client.room
import de.connect2x.trixnity.client.room.RoomService
import de.connect2x.trixnity.client.room.getState
import de.connect2x.trixnity.client.store.eventId
import de.connect2x.trixnity.clientserverapi.model.room.GetEvents
import de.connect2x.trixnity.core.model.EventId
import de.connect2x.trixnity.core.model.RoomId
import de.connect2x.trixnity.core.model.UserId
import de.connect2x.trixnity.core.model.events.m.room.TopicEventContent
import dev.jfronny.zerointerest.Destination
import dev.jfronny.zerointerest.data.TransactionTemplate
import dev.jfronny.zerointerest.data.ZeroInterestSummaryEvent
import dev.jfronny.zerointerest.data.ZeroInterestTransactionEvent
import dev.jfronny.zerointerest.data.ZiConfigStateEvent
import dev.jfronny.zerointerest.data.money.MonetaryUnit
import dev.jfronny.zerointerest.data.money.Money
import dev.jfronny.zerointerest.db.ZeroInterestDatabase
import dev.jfronny.zerointerest.service.Settings
import dev.jfronny.zerointerest.service.SummaryTrustService
import dev.jfronny.zerointerest.service.TransactionService
import dev.jfronny.zerointerest.service.client.MatrixClientService
import dev.jfronny.zerointerest.shared.generated.resources.*
import dev.jfronny.zerointerest.ui.component.BackButton
import dev.jfronny.zerointerest.ui.component.MonetaryUnitDialog
import dev.jfronny.zerointerest.ui.component.MoreOptionsButton
import dev.jfronny.zerointerest.ui.component.PreviewUserUI
import dev.jfronny.zerointerest.ui.component.RoomInfoSheet
import dev.jfronny.zerointerest.ui.component.UnsupportedRoomProtocolContent
import dev.jfronny.zerointerest.ui.component.UserUI
import dev.jfronny.zerointerest.ui.component.rememberRoomInfoSheetData
import dev.jfronny.zerointerest.ui.component.rememberTransactionLauncher
import dev.jfronny.zerointerest.ui.theme.AppTheme
import dev.jfronny.zerointerest.util.Navigator
import dev.jfronny.zerointerest.util.room
import dev.jfronny.zerointerest.util.toEntries
import io.github.oshai.kotlinlogging.KotlinLogging
import kotlin.time.Duration.Companion.seconds
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.ImmutableMap
import kotlinx.collections.immutable.ImmutableSet
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.persistentMapOf
import kotlinx.collections.immutable.persistentSetOf
import kotlinx.collections.immutable.plus
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.mapNotNull
import kotlinx.coroutines.flow.toList
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject

private val log = KotlinLogging.logger {}

@OptIn(ExperimentalMaterial3ExpressiveApi::class, ExperimentalMaterial3Api::class)
@Composable
fun RoomScreen(
    roomId: RoomId,
    onBack: () -> Unit,
    onAddTransaction: (TransactionTemplate?) -> Unit,
    openSettings: () -> Unit,
    navHelper: Navigator,
) {
    val service = koinInject<MatrixClientService>()
    val rxclient by service.client.collectAsState(null)
    val client = rxclient ?: return
    val rxziClient by service.ziClient.collectAsState(null)
    val ziClient = rxziClient ?: return
    val trust = koinInject<SummaryTrustService>()
    val transactions = koinInject<TransactionService>()
    val database = koinInject<ZeroInterestDatabase>()
    val roomNavHelper = navHelper.room()
    val roomIs = roomNavHelper.roomIs()
    val scope = rememberCoroutineScope()

    NavigationSuiteScaffold(navigationItems = {
        NavigationSuiteItem(
            selected = roomIs(Destination.Room.RoomDestination.Balance),
            onClick = { roomNavHelper.navigateTab(Destination.Room.RoomDestination.Balance) },
            icon = { Icon(Icons.Default.Paid, stringResource(Res.string.balances)) },
            label = { Text(stringResource(Res.string.balances)) },
        )
        NavigationSuiteItem(
            selected = roomIs(Destination.Room.RoomDestination.Transactions),
            onClick = { roomNavHelper.navigateTab(Destination.Room.RoomDestination.Transactions) },
            icon = { Icon(Icons.AutoMirrored.Filled.CompareArrows, stringResource(Res.string.transactions)) },
            label = { Text(stringResource(Res.string.transactions)) },
        )
    }) {
        val settings = koinInject<Settings>()
        val flipBalances by settings.flipBalances.collectAsState(initial = true)
        val debugHints by settings.debugHints.collectAsState(initial = false)

        // Do NOT use rxroomConfig since that will cause the remembered entryProvider to capture the value
        val roomConfig by ziClient.getRoomConfigFlow(roomId).collectAsState(ZiConfigStateEvent.Unknown)
        val launcher = rememberTransactionLauncher(ziClient)
        var showUpgradeDialog by remember { mutableStateOf(false) }
        var showCurrencyDialog by remember { mutableStateOf(false) }

        fun sendRoomConfig(currency: MonetaryUnit) {
            launcher.tryLaunch {
                (ziClient.getRoomConfig(roomId) as? ZiConfigStateEvent.Newer)?.let { newer ->
                    throw TransactionService.UnsupportedRoomProtocolException(newer.version)
                }
                ziClient.sendStateEvent(
                    roomId,
                    ZiConfigStateEvent.V1(rawCurrency = currency.code),
                    ZiConfigStateEvent.TYPE,
                ).fold(
                    onSuccess = {},
                    onFailure = { throw TransactionService.FailedSendMessageException(cause = it) },
                )
            }
        }

        var forceReload by remember { mutableIntStateOf(0) }
        val flow = remember(roomId, forceReload) { trust.getSummary(roomId) }
        val event by flow.collectAsState(null)

        var showRoomInfoSheet by remember { mutableStateOf(false) }

        val room by client.room.getById(roomId).collectAsState(null)
        val topic by client.room.getState<TopicEventContent>(roomId)
            .map { it?.content?.topic?.text?.plain ?: "" }
            .collectAsState("")

        Scaffold(
            topBar = {
                TopAppBar(
                    expandedHeight = TopAppBarDefaults.TopAppBarExpandedHeight,
                    title = {
                        Column(
                            modifier = Modifier
                                .height(TopAppBarDefaults.TopAppBarExpandedHeight)
                                .fillMaxWidth()
                                .clickable { showRoomInfoSheet = true },
                            horizontalAlignment = Alignment.Start,
                            verticalArrangement = Arrangement.Center,
                        ) {
                            Text(text = room?.name?.explicitName ?: stringResource(Res.string.room))
                            if (topic.isNotBlank()) {
                                Text(
                                    text = topic,
                                    style = TextStyle.Default,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis,
                                )
                            }
                        }
                    },
                    navigationIcon = {
                        BackButton(onBack = onBack)
                    },
                    actions = {
                        MoreOptionsButton(openSettings = openSettings) { close ->
                            DropdownMenuItem(
                                text = { Text(stringResource(Res.string.room_info)) },
                                onClick = {
                                    close()
                                    showRoomInfoSheet = true
                                },
                            )
                        }
                    },
                )
            },
            floatingActionButton = fab@{
                if (roomConfig is ZiConfigStateEvent.Newer) return@fab
                if (event == null || event is SummaryTrustService.Summary.Untrusted) return@fab

                val templatesFlow = remember(roomId) { database.getTransactionTemplates(roomId) }
                val templates by templatesFlow.collectAsState(emptyList())

                if (templates.isEmpty()) {
                    FloatingActionButton(onClick = { onAddTransaction(null) }) {
                        Icon(Icons.Default.Add, stringResource(Res.string.add_transaction))
                    }
                } else {
                    var expanded by remember { mutableStateOf(false) }
                    Box {
                        FloatingActionButtonMenu(
                            expanded = expanded,
                            button = {
                                TooltipBox(
                                    positionProvider = TooltipDefaults.rememberTooltipPositionProvider(
                                        if (expanded) TooltipAnchorPosition.Start else TooltipAnchorPosition.Above,
                                    ),
                                    tooltip = { PlainTooltip { Text(stringResource(Res.string.new_transaction)) } },
                                    state = rememberTooltipState(),
                                ) {
                                    ToggleFloatingActionButton(
                                        checked = expanded,
                                        onCheckedChange = { expanded = it },
                                    ) {
                                        Icon(Icons.Default.Add, stringResource(Res.string.add_transaction))
                                    }
                                }
                            },
                        ) {
                            FloatingActionButtonMenuItem(
                                text = { Text(stringResource(Res.string.new_transaction)) },
                                icon = { Icon(Icons.Default.Add, stringResource(Res.string.new_transaction)) },
                                onClick = {
                                    expanded = false
                                    onAddTransaction(null)
                                },
                            )
                            templates.forEach { template ->
                                FloatingActionButtonMenuItem(
                                    text = { Text(template.description) },
                                    icon = { Icon(Icons.AutoMirrored.Filled.NoteAdd, stringResource(Res.string.add_transaction)) },
                                    onClick = {
                                        expanded = false
                                        onAddTransaction(template)
                                    },
                                )
                            }
                        }
                    }
                }
            },
        ) { padding ->
            when (roomConfig) {
                is ZiConfigStateEvent.Newer, ZiConfigStateEvent.Unknown -> {
                    UnsupportedRoomProtocolContent(
                        version = roomConfig.version,
                        modifier = Modifier.fillMaxSize().padding(padding),
                    )
                    return@Scaffold
                }

                is ZiConfigStateEvent.Acceptable -> {}
            }

            val entryProvider = remember {
                // type hint is needed for kotlin/js
                entryProvider<Destination.Room.RoomDestination> {
                    entry<Destination.Room.RoomDestination.Balance> {
                        event?.let {
                            val roomConfig = roomConfig as? ZiConfigStateEvent.Acceptable ?: return@entry
                            BalancesTab(
                                summary = it,
                                userUI = UserUI(client, roomId),
                                flipBalances = flipBalances,
                                debugHints = debugHints,
                                monetaryUnit = roomConfig.currency,
                                forceTrust = {
                                    scope.launch {
                                        trust.forceAccept(it)
                                        forceReload++
                                    }
                                },
                            )
                        } ?: run {
                            Box(
                                modifier = Modifier.fillMaxSize(),
                                contentAlignment = Alignment.Center,
                            ) {
                                LoadingIndicator(Modifier.size(128.dp))
                            }
                        }
                    }
                    entry<Destination.Room.RoomDestination.Transactions> {
                        val roomConfig = roomConfig as? ZiConfigStateEvent.Acceptable ?: return@entry
                        TransactionsTab(client, roomId, navHelper, roomConfig.currency)
                    }
                }
            }

            NavDisplay(
                entries = roomNavHelper.stack.toEntries(entryProvider),
                onBack = { roomNavHelper.main.goBack() },
                modifier = Modifier.padding(padding),
            )
        }

        if (showRoomInfoSheet) {
            RoomInfoSheet(
                data = rememberRoomInfoSheetData(roomId, room, roomConfig, topic),
                onDismiss = { showRoomInfoSheet = false },
                onToggleFavorite = {
                    scope.launch { settings.setFavoriteRoom(roomId, it) }
                },
                onSetTopic = { topic ->
                    scope.launch {
                        client.api.room.sendStateEvent(
                            roomId = roomId,
                            eventContent = TopicEventContent(topic),
                        )
                    }
                },
                onSettleUp = {
                    navHelper.navigate(Destination.SettleScreen(roomId))
                },
                onSetCurrency = { showCurrencyDialog = true },
                onUpgradeRoom = { showUpgradeDialog = true },
                onDebugNewSummary = {
                    scope.launch {
                        val preparedSummary =
                            transactions.prepareSummaryCreation(roomId, emptyList())
                        transactions.createSummary(preparedSummary, emptyList())
                    }
                },
                onDebugResetTrust = {
                    scope.launch {
                        database.resetTrust(roomId)
                    }
                },
                onOpenSettings = openSettings,
            )
        }

        if (launcher.state.error != null) {
            launcher.ErrorDialog(onDismiss = launcher::clearError)
        }

        if (showUpgradeDialog) {
            MonetaryUnitDialog(
                title = stringResource(Res.string.upgrade_room),
                current = MonetaryUnit.default,
                onClose = { showUpgradeDialog = false },
                onSave = {
                    showUpgradeDialog = false
                    sendRoomConfig(it)
                },
            )
        }

        if (showCurrencyDialog) {
            MonetaryUnitDialog(
                title = stringResource(Res.string.room_currency),
                current = (roomConfig as? ZiConfigStateEvent.Acceptable)?.currency ?: MonetaryUnit.default,
                onClose = { showCurrencyDialog = false },
                onSave = {
                    showCurrencyDialog = false
                    sendRoomConfig(it)
                },
            )
        }
    }
}

@Composable
private fun BalancesTab(
    summary: SummaryTrustService.Summary,
    userUI: UserUI,
    flipBalances: Boolean,
    debugHints: Boolean,
    monetaryUnit: MonetaryUnit,
    forceTrust: (SummaryTrustService.Summary.Untrusted) -> Unit,
) {
    when (summary) {
        SummaryTrustService.Summary.Empty -> {
            Box(Modifier.fillMaxSize()) {
                Text(stringResource(Res.string.no_balances_yet), Modifier.align(Alignment.Center), style = MaterialTheme.typography.bodyLarge)
            }
        }

        is SummaryTrustService.Summary.Untrusted -> {
            Box(Modifier.fillMaxSize()) {
                Column(Modifier.align(Alignment.Center), horizontalAlignment = Alignment.CenterHorizontally) {
                    Text(stringResource(Res.string.latest_summary_not_trusted), style = MaterialTheme.typography.bodyLarge)
                    Button(onClick = { forceTrust(summary) }) {
                        Text(stringResource(Res.string.override))
                    }
                }
            }
        }

        is SummaryTrustService.Summary.Trusted -> {
            val balances = summary.event.balances
            // TODO this might not perform well with many users
            //     consider that after it becomes a problem.
            val uiBalances = balances.entries
                .map { (k, v) -> v to userUI.component(k) }
                .sortedBy { it.second.name }
            LazyColumn(modifier = Modifier.fillMaxWidth()) {
                if (summary.isMerge && debugHints) {
                    item {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(16.dp),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Icon(Icons.Default.Warning, contentDescription = null, tint = MaterialTheme.colorScheme.error)
                            Spacer(Modifier.width(8.dp))
                            Text(stringResource(Res.string.summary_is_merge), style = MaterialTheme.typography.bodyMedium, color = MaterialTheme.colorScheme.error)
                        }
                    }
                }
                items(uiBalances) { (balance, ui) ->
                    val color = when {
                        balance.amount > 0 -> MaterialTheme.colorScheme.error
                        else -> MaterialTheme.colorScheme.primary
                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 8.dp),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        ui()
                        Spacer(modifier = Modifier.weight(1f))
                        Text(
                            text = (if (flipBalances) -balance else balance).format(monetaryUnit),
                            color = color,
                        )
                    }
                }
            }
        }
    }
}

@Preview
@Composable
private fun BalancesTabPreview() = AppTheme {
    BalancesTab(
        summary = SummaryTrustService.Summary.Trusted(
            ZeroInterestSummaryEvent(
                balances = mapOf(
                    UserId("@alice:example.org") to Money(4200),
                    UserId("@carol:example.org") to Money.zero,
                    UserId("@bob:example.org") to Money(-1550),
                ),
                parents = emptyMap(),
            ),
            isMerge = true,
        ),
        userUI = PreviewUserUI,
        flipBalances = true,
        debugHints = true,
        monetaryUnit = MonetaryUnit.default,
        forceTrust = {},
    )
}

@Composable
private fun TransactionsTab(
    client: MatrixClient,
    roomId: RoomId,
    navHelper: Navigator,
    monetaryUnit: MonetaryUnit,
) {
    val roomService: RoomService = client.room
    val trust = koinInject<SummaryTrustService>()

    // State to hold the list of transaction events
    var transactionEvents by remember(roomId) { mutableStateOf<PersistentList<Pair<EventId, ZeroInterestTransactionEvent>>>(persistentListOf()) }
    var isLoading by remember(roomId) { mutableStateOf(true) }
    var hasMore by remember(roomId) { mutableStateOf(true) }

    val listState = rememberLazyListState()

    // Keep a set of already loaded ids for deduplication when paging
    val loadedIds = remember(roomId) { mutableSetOf<EventId>() }
    // Reload included transactions when coming back to the screen
    val includedTransactionsFlow = remember(roomId, transactionEvents) {
        flow {
            emit(trust.getSummariesReferencingTransactions(roomId, transactionEvents.map { it.first }.toSet()))
        }
    }
    val includedTransactions by includedTransactionsFlow.collectAsState(persistentMapOf())

    // Reuse name resolver so it isn't created per-row
    val userUI = UserUI(client, roomId)

    // Track the oldest loaded event id to continue paging from there
    var oldestLoadedId by remember(roomId) { mutableStateOf<EventId?>(null) }

    val pageSize = 50

    // Small helper to load one page from a start event id going backwards
    suspend fun loadPage(startFrom: EventId) {
        log.info { "Loading transactions page content from $startFrom" }
        isLoading = true
        try {
            var emittedCount = 0
            var lastSeenId: EventId? = null

            val newItems = roomService.getTimelineEvents(
                roomId = roomId,
                startFrom = startFrom,
                direction = GetEvents.Direction.BACKWARDS,
                config = {
                    minSize = pageSize.toLong()
                    maxSize = pageSize.toLong()
                    fetchTimeout = 5.seconds
                    allowReplaceContent = false
                },
            ).mapNotNull { timelineEventFlow ->
                emittedCount++
                val firstEvent = timelineEventFlow.first()
                lastSeenId = firstEvent.eventId

                // Get the first emission with a usable content for this timeline event
                val content = firstEvent.content?.getOrNull()
                if (content is ZeroInterestTransactionEvent && loadedIds.add(firstEvent.eventId)) {
                    (firstEvent.eventId to content)
                } else {
                    null
                }
            }.toList()

            if (newItems.isNotEmpty()) {
                // Append to the end to keep newest-to-oldest ordering
                transactionEvents = (transactionEvents + newItems)
            }
            // Advance the anchor if we processed any events at all
            if (lastSeenId != null) {
                oldestLoadedId = lastSeenId
            }

            log.info { "Successfully loaded $emittedCount of $pageSize elements" }
            // Decide if there may be more events to load
            hasMore = emittedCount > pageSize
        } catch (e: Exception) {
            // Error while loading a page should stop further paging in this session
            log.error(e) { "Error loading transactions page" }
            hasMore = false
        } finally {
            isLoading = false
        }
    }

    // Initial load
    LaunchedEffect(roomId) {
        isLoading = true
        transactionEvents = persistentListOf()
        hasMore = true
        loadedIds.clear()
        oldestLoadedId = null

        try {
            val room = roomService.getById(roomId).first()
            val lastEventId = room?.lastEventId

            if (lastEventId != null) {
                loadPage(startFrom = lastEventId)
            } else {
                // No events in this room
                isLoading = false
                hasMore = false
            }
        } catch (e: Exception) {
            log.error(e) { "Error loading transactions" }
            isLoading = false
            hasMore = false
        }
    }

    // Detect when user scrolls near the end to load more
    val shouldLoadMore by remember {
        derivedStateOf {
            if (!hasMore || isLoading) return@derivedStateOf false

            val layoutInfo = listState.layoutInfo
            val totalItemsNumber = layoutInfo.totalItemsCount
            val lastVisibleItemIndex = layoutInfo.visibleItemsInfo.lastOrNull()?.index ?: 0

            totalItemsNumber > 0 && lastVisibleItemIndex >= totalItemsNumber - 5
        }
    }

    // Load more when scrolling near end
    LaunchedEffect(shouldLoadMore) {
        if (shouldLoadMore && hasMore && !isLoading) {
            val anchor = oldestLoadedId
            if (anchor != null) {
                loadPage(startFrom = anchor)
            }
        }
    }

    TransactionsTabContent(
        isLoading = isLoading,
        listState = listState,
        userUI = userUI,
        transactionEvents = transactionEvents,
        includedTransactions = includedTransactions,
        monetaryUnit = monetaryUnit,
        onShowDetails = { navHelper.navigate(Destination.TransactionDetails(roomId, it)) },
    )
}

@OptIn(ExperimentalMaterial3ExpressiveApi::class)
@Composable
private fun TransactionsTabContent(
    isLoading: Boolean,
    transactionEvents: ImmutableList<Pair<EventId, ZeroInterestTransactionEvent>>,
    listState: LazyListState,
    includedTransactions: ImmutableMap<EventId, ImmutableSet<EventId>>,
    userUI: UserUI,
    monetaryUnit: MonetaryUnit,
    onShowDetails: (EventId) -> Unit,
) {
    Box(modifier = Modifier.fillMaxSize()) {
        if (isLoading && transactionEvents.isEmpty()) {
            LoadingIndicator(modifier = Modifier.align(Alignment.Center))
        } else {
            LazyColumn(
                modifier = Modifier.fillMaxWidth(),
                state = listState,
            ) {
                items(
                    items = transactionEvents,
                    key = { it.first.full },
                ) { (eventId, transaction) ->
                    TransactionTabItem(
                        transaction = transaction,
                        included = includedTransactions[eventId]?.isNotEmpty() ?: false,
                        userUI = userUI,
                        monetaryUnit = monetaryUnit,
                        onClick = { onShowDetails(eventId) },
                    )
                }

                // Show loading indicator at the bottom when loading more
                if (isLoading && transactionEvents.isNotEmpty()) {
                    item {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(16.dp),
                            contentAlignment = Alignment.Center,
                        ) {
                            LoadingIndicator()
                        }
                    }
                }

                if (!isLoading && transactionEvents.isEmpty()) {
                    item {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(16.dp),
                            contentAlignment = Alignment.Center,
                        ) {
                            Text(stringResource(Res.string.no_transactions_yet))
                        }
                    }
                }
            }
        }
    }
}

@Preview
@Composable
private fun TransactionTabContentPreview() = AppTheme {
    TransactionsTabContent(
        isLoading = false,
        transactionEvents = persistentListOf(
            EventId("1") to ZeroInterestTransactionEvent(
                sender = UserId("@alice:example.org"),
                description = ZeroInterestTransactionEvent.PAYMENT_DESCRIPTION,
                receivers = mapOf(
                    UserId("@bob:example.org") to Money(1000),
                    UserId("@carol:example.org") to Money(-500),
                ),
            ),
            EventId("2") to ZeroInterestTransactionEvent(
                sender = UserId("@bob:example.org"),
                description = ZeroInterestTransactionEvent.PAYMENT_DESCRIPTION,
                receivers = mapOf(
                    UserId("@alice:example.org") to Money(1000),
                    UserId("@carol:example.org") to Money(-500),
                ),
            ),
        ),
        listState = rememberLazyListState(),
        includedTransactions = persistentMapOf(EventId("2") to persistentSetOf(EventId("sum"))),
        userUI = PreviewUserUI,
        monetaryUnit = MonetaryUnit.default,
        onShowDetails = {},
    )
}

@Composable
private fun TransactionTabItem(
    transaction: ZeroInterestTransactionEvent,
    included: Boolean,
    userUI: UserUI,
    monetaryUnit: MonetaryUnit,
    onClick: () -> Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp, vertical = 8.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        val component = userUI.component(transaction.sender)
        component.Icon()
        Spacer(Modifier.width(8.dp))
        Column {
            Row(verticalAlignment = Alignment.CenterVertically) {
                if (transaction.description == ZeroInterestTransactionEvent.PAYMENT_DESCRIPTION) {
                    Text(text = stringResource(Res.string.payment), style = MaterialTheme.typography.titleMedium)
                } else {
                    Text(text = transaction.description, style = MaterialTheme.typography.titleMedium)
                }
                if (!included) {
                    Spacer(Modifier.width(4.dp))
                    Icon(
                        Icons.Default.Warning,
                        contentDescription = stringResource(Res.string.not_included_in_summary),
                        tint = MaterialTheme.colorScheme.error,
                        modifier = Modifier.size(16.dp),
                    )
                }
            }
            Text(text = component.name, style = MaterialTheme.typography.bodySmall)
        }
        Spacer(modifier = Modifier.weight(1f))
        Text(text = transaction.total.format(monetaryUnit))
    }
}

@Preview
@Composable
private fun TransactionTabItemPreview() = AppTheme {
    TransactionTabItem(
        transaction = ZeroInterestTransactionEvent(
            sender = UserId("@alice:example.org"),
            description = ZeroInterestTransactionEvent.PAYMENT_DESCRIPTION,
            receivers = mapOf(
                UserId("@bob:example.org") to Money(1000),
                UserId("@carol:example.org") to Money(-500),
            ),
        ),
        included = true,
        userUI = PreviewUserUI,
        monetaryUnit = MonetaryUnit.default,
        onClick = {},
    )
}
